<div
  *ngIf="visible"
  class="edit-lock-banner"
  role="alert">
  <i class="pi pi-lock edit-lock-icon"></i>
  <div class="edit-lock-text">
    <strong>In uso da un altro utente</strong>
    <span *ngIf="holder"> ({{ holder }})</span>
    <div
      *ngIf="view.status === 'lost'"
      class="edit-lock-detail">
      Il ticket è stato preso in carico da un altro utente mentre eri inattivo: le modifiche fatte qui non
      possono essere salvate.
    </div>
    <div
      *ngIf="view.status === 'blocked'"
      class="edit-lock-detail">
      Puoi consultarlo, ma non modificarlo finché l'altro utente non ha finito.
    </div>
  </div>
  <div class="edit-lock-actions">
    <p-button
      type="button"
      label="Riprova"
      icon="pi pi-refresh"
      styleClass="butt"
      [rounded]="true"
      [loading]="view.busy"
      (onClick)="retry.emit()"></p-button>
    <ng-container *hasGrants="['TICKETS.FORCE_UNLOCK']">
      <p-button
        type="button"
        label="Forza sblocco"
        icon="pi pi-unlock"
        styleClass="p-button-outlined p-button-danger"
        [rounded]="true"
        [disabled]="view.busy"
        (onClick)="confirmForce()"></p-button>
    </ng-container>
  </div>
</div>
